import {useState, useEffect} from 'react';

const format = time => {
    const days = Math.floor(time / (24 * 60 * 60 * 1e3));
    time -= days * (24 * 60 * 60 * 1e3);

    const hours = Math.floor(time / (60 * 60 * 1e3));
    time -= hours * (60 * 60 * 1e3);

    const minutes = Math.floor(time / 60e3);

    return `${days < 10 ? `0${days}` : days}d ${hours < 10 ? `0${hours}` : hours}h ${minutes < 10 ? `0${minutes}` : minutes}m`;
}

export default ({
    timestamp,
    timeoutKey
}) => {
    const [time, setTime] = useState(timestamp - Date.now());

    useEffect(() => {
        window[timeoutKey] = setTimeout(() => {
            setTime(timestamp - Date.now());
        }, 500);

        return () => clearTimeout(window[timeoutKey]);
    }, [time]);

    return format(time);
}